import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
    UpdateCv: null
};

export const getMarketingLeadList = createAsyncThunk(
    "getMarketingLeadList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/MarketingLead/fetch-marketing-leads?page=${body.page}&search=${body.search}&platform=${body.platform}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);

export const uploadCvLead = createAsyncThunk(
    "uploadCvLead",
    async (body) => {
        const formData = new FormData();
        formData.append("excelfile", body);
        try {
            const res = await instance.post("/remark/MarketingLead/upload-marketing-lead-excel", formData)
            return res.data
        } catch (error) {
            return error
        }
    }
)

export const addNewMarketingLead = createAsyncThunk(
    "addNewMarketingLead",
    async (data) => {
        try {
            const response = await instance.post(`/remark/MarketingLead/create-marketing-lead`, data);
            return response.data;
        }
        catch (error) {
            throw error;
        }
    }
)

export const MarketingLeadSlice = createSlice({
    name: "MarketingLeadSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getMarketingLeadList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getMarketingLeadList.fulfilled, (state, action) => {

            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(getMarketingLeadList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        builder.addCase(uploadCvLead.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(uploadCvLead.fulfilled, (state, action) => {
            state.loading = false;
            state.UpdateCv = action.payload;
        });
        builder.addCase(uploadCvLead.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        });
        builder.addCase(addNewMarketingLead.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(addNewMarketingLead.fulfilled, (state, action) => {
            state.loading = false;
            state.UpdateCv = action.payload;
        });
        builder.addCase(addNewMarketingLead.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        });

    },
});

export default MarketingLeadSlice.reducer;
